import React, { Component } from 'react'
import { Checkbox } from 'antd'
import { Field } from '../../../../styles'
import { withTranslation } from 'react-i18next'
import './styles.scss'

class OrganizationPicker extends Component {
    handleChange = (id, e) => {
        const { onChange } = this.props

        if (onChange) {
            onChange(id)
        }
    }
    getFirstLetter = title => {
        return title ? title.charAt(0).toUpperCase() : ''
    }

    render() {
        const { list, selectedOrganizations, t } = this.props

        return (
            <Field>
                <Field.Label>{t('labels:select_organization')}</Field.Label>
                <div className="org-group">
                    <div className="org-group-row">
                        {Array.isArray(list) && list.map(organization => {
                            const { id, title, logo } = organization
                            const isActive = selectedOrganizations.includes(id)
                            return (
                                <div className="org-group-item-container" key={id}>
                                    <div
                                        className={`org-group-btn ${isActive ? 'active' : ''}`}
                                        onClick={e => this.handleChange(id, e)}
                                    >
                                        <div className="org-checkbox-wrapper">
                                            <Checkbox checked={selectedOrganizations.includes(id)} />
                                        </div>
                                        {logo ? (
                                            <img src={logo.link} alt={title} className="org-image" />
                                        ) : (
                                            <div className="org-initial">
                                                {this.getFirstLetter(title)}
                                            </div>
                                        )}
                                        <div className="org-name">
                                            {title}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Field>
        )
    }
}

export default withTranslation(['quest', 'labels'])(OrganizationPicker)
